import { createSelector } from '@reduxjs/toolkit';

import type { FilesKeyframeSchemaWithId } from '@iconik-io/iconik-api/src/services/files';

import { createEntitiesIndexSelector } from '../../entities_index/selectors';

export const selectKeyframesByAssetId = createEntitiesIndexSelector(
  'keyframes',
  'asset_id',
);

export const selectKeyframesByVersionIdMap = createSelector(
  selectKeyframesByAssetId,
  (keyframes) => {
    const result: Record<string, FilesKeyframeSchemaWithId[]> = {};
    for (const keyframe of keyframes) {
      if ('version_id' in keyframe && keyframe.version_id) {
        if (!result[keyframe.version_id]) {
          result[keyframe.version_id] = [];
        }
        result[keyframe.version_id].push(keyframe);
      }
    }
    return result;
  },
);
